import { Observable } from "rxjs";
import { InjectionToken } from "@angular/core";

export const autocompleteServiceToken = new InjectionToken<AutocompleteService>('Autocomplete Service');

export abstract class AutocompleteService {
  abstract searchAddress(term: string): Observable<string[]>;
}
